import { useTranslation } from 'react-i18next'

export const useClaimTypeDisplay = (type: string) => {
  const { t } = useTranslation('claimsSearch', { keyPrefix: 'claimTypes' })

  switch (type.toLowerCase()) {
    case 'inpatient':
      return t('inpatient')
    case 'outpatient':
      return t('outpatient')
    case 'partb':
      return t('partB')
    case 'homehealth':
      return t('homeHealth')
    case 'hospice':
      return t('hospice')
    case 'dme':
      return t('dme')
    default:
      return type
  }
}
